<template>
  <header class="d-flex justify-content-between align-items-center" style="background-color: #198754;">
    <label for="toggle-1" class="toggle-menu" @click="toggleMenu">
      <ul>
        <li></li>
        <li></li>
        <li></li>
      </ul>
    </label>
    <!-- <strong @click="toggleMenu"> &#9776;	</strong> -->
    <nav class="nav_center" style="padding: 0" :style="{ display: isMenuVisible ? 'block' : 'none' }">
      <ul style="list-style: none">





        <li :class="{ topmenuactive: activeTab === 'ThietBi' }" @click="changeTab('ThietBi')">
          <a id="urlThietBi">{{
            currentLanguage.thietbi
            }}</a>
        </li>
        <li :class="{ topmenuactive: activeTab === 'qRTaiKhoan' }" @click="changeTab('qRTaiKhoan')">
          <a id="urlCTQRTaiKhoan" style=" color: white; ">{{ currentLanguage.header_text_QRtaikhoantrunggian }}
          </a>
        </li>
         <li :class="{ topmenuactive: activeTab === 'CoSoYTeXa' }" @click="changeTab('CoSoYTeXa')">
          <a id="urlThanhtoan" style="color: white; display: none;">{{ currentLanguage.header_text_qrThanhToan  }} Offline</a>
        </li>
        <li :class="{ topmenuactive: activeTab === 'Vivimass' }" @click="changeTab('Vivimass')">
          <a id="urlVivimass">{{
            currentLanguage.header_text_viDienTu
            }}</a>

        </li>
      
        <li :class="{ topmenuactive: activeTab === 'thevimass' }" @click="changeTab('thevimass')">
          <a id="urlCTThiDiem">{{ currentLanguage.header_text_ungDung_theDaNang }}
          </a>
        </li>


       
        <li :class="{ topmenuactive: activeTab === 'DichVu' }" @click="changeTab('DichVu')" style="display: none;">
          <a id="urlDichVu">{{ currentLanguage.header_text_phiDichVu }}  </a>
        </li>
  <li :class="{ topmenuactive: activeTab === 'ContactNV' }" @click="changeTab('ContactNV')">
          <a id="urlContactNV">{{ currentLanguage.header_text_lienHe }}</a>
        </li>
      </ul>
    </nav>
    <div class="menu_right" style="display: flex">
      <div class="menu_co_right" style="display: flex">
         <a @click="changeLanguage('hu')" class="lang" style="padding: 5px"><img
            src="https://web.vimass.vn/VimassMedia/services/VMMedia/getImage?id=1774504537907WeDTF"  style="width: 25px;"/>
        </a>
        <a @click="changeLanguage('vi')" class="lang" style="padding: 5px"><img
            src="img/img-item-vimass-2022/co/vi-VN.gif" />
        </a>
        <a @click="changeLanguage('en')" class="lang" style="padding: 5px"><img style="width: 25px"
            src="img/img-item-vimass-2022/co/us.png" />
        </a>
        <a @click="changeLanguage('cn')" class="lang d-none" style="padding: 5px"><img style="width: 25px"
            src="img/img-item-vimass-2022/co/cn.jpg" />
        </a>
        <a @click="changeLanguage('kr')" class="lang d-none" style="padding: 5px"><img style="width: 25px ; "
            src="img/img-item-vimass-2022/co/kr.jpg" />
        </a>

        <a @click="changeLanguage('ja')" class="lang d-none" style="padding: 5px"><img style="width: 25px ;"
            src="img/img-item-vimass-2022/co/ja.jpg" />
        </a>

        <span class="clickShow" style="color: #303038; cursor: pointer; margin: auto"><i class="fa fa-ellipsis-h"
            aria-hidden="true"></i></span>

      </div>
      <a id="urlHome" href="/" style="margin: 0 10px"><img style="width: 35px; height: 35px"
          src="img/home-icon-white-8.jpg" />
      </a>
    </div>
  </header>
  <div class="wrapper row3">
    <main class="hoc container-fluid clear bv">
      <div v-show="activeThietBi" class="min-h--500p">
        <MainSanPham />
      </div>
      <div v-if="activePhi" class="min-h--500p">
        <PhiDichVuVer2 />
      </div>
      <!-- gioi thieu -->
      <div id="thevimass" v-show="showThevimass" style="min-height: 500px" class="padding-top15">
        <div class="title-bai-viet" v-html="titleThevimass"></div>
        <div v-html="contentThevimass"></div>
      </div>

      <!-- gioi thieu -->
      <div id="qRTaiKhoan" v-show="showQRTaiKhoan" style="min-height: 500px" class="padding-top15">
        <div class="title-bai-viet" v-html="titleQRTaiKhoan"></div>
        <div v-html="contentQRTaiKhoan"></div>
      </div>
      <!-- tieu hoc-->
      <div id="ContactNV" v-show="showContactNV"
        style="min-height: 500px; background-image: none !important" class="padding-top15">
        <div class="title-bai-viet" v-html="titleContactNV"></div>
        <div v-html="contentContactNV"></div>
      </div>
      <!-- Vivimass -->
      <div id="Vivimass" v-show="showVivimass" style="min-height: 500px; background-image: none !important"
        class="padding-top15">
        <div class="title-bai-viet" v-html="titleVivimass"></div>
        <div v-html="contentVivimass"></div>
      </div>
      <!-- CoSoYTeXa -->
      <div id="CoSoYTeXa" v-show="showCoSoYTeXa" style="min-height: 500px; background-image: none !important"
        class="padding-top15">
        <div class="title-bai-viet"> Thanh toán thông minh không Internet</div>
        <div >Đang cập nhật...</div>
      </div>

        <!-- <div id="thanToankoInternet" v-show="showCoSoYTeXa" style="min-height: 500px; background-image: none !important"
        class="padding-top15">
        <div class="title-bai-viet" v-html="titleCoSoYTeXa"></div>
        <div v-html="contentCoSoYTeXa"></div>
      </div> -->
      <!-- LIEN HE -->
      <div id="lienhe" v-show="showLienHe" style="min-height: 500px; background-image: none !important">
        <div class="title-bai-viet" v-html="titleLienHe"></div>
        <div v-html="contentLienHe"></div>
      </div>

    </main>
  </div>
  <FooterView></FooterView>
</template>
<script>
import FooterView from "../FooterView/FooterView.vue";
import { languages } from "@/assets/js/languagesVMHU.js";
import { apiChiTietBaiViet } from "@/components/listService";
import axios from "axios";
import MainSanPham from "@/views/8_View_Layer/MainBaiVietCon/MainSanPham.vue";
// import { vmCrop } from "@/components/axiosVM";

export default {
  components: {
    FooterView, MainSanPham,
  },
  data() {
    return {
      activeTab: "qRTaiKhoan",
      isMenuVisible: false,
      currentLanguage: languages.vi,
      lang: "",
      base64: "",
      base64Title: "",

      //show
      showThevimass: false,
      showContactNV: false,
      showVivimass: false,
      showCoSoYTeXa: false,
      showLienHe: false,
      showQRTaiKhoan: true,

      //active tab
      isActiveThevimass: false,
      isActiveContactNV: false,
      isActiveVivimass: false,
      isAcitveCoSoYTeXa: false,
      isActiveLienHe: false,
      isActiveQRTaiKhoan: true,

      //title
      titleThevimass: "",
      titleContactNV: "",
      titleVivimass: "",
      titleCoSoYTeXa: "",
      titleLienHe: "",
      titleQRTaiKhoan: "",

      //content
      contentThevimass: "",
      contentContactNV: "",
      contentVivimass: "",
      contentCoSoYTeXa: "",
      contentLienHe: "",
      contentQRTaiKhoan: "",

      hasMounted: false,

      activeThietBi: false,
      activePhi: false,
    };
  },
  mounted() {
    if (window.innerWidth <= 768) {
      this.isMenuVisible = false;
    } else {
      this.isMenuVisible = true;
    }
    if (!this.hasMounted) {
      this.hasMounted = true;
      this.lang = localStorage.getItem("languages") || "hu";
      const titleMap = {
        vi: "Vimass.vn - Thiết bị thiết yếu",
        en: "Vimass.vn - Smart public services",
        cn: "Vimass.vn - Smart public services",
      };
      document.title = titleMap[this.lang] || "Vimass.vn - Thiết bị thiết yếu";

      // this.performPostRequest("1752549940885h0Sxh", "thevimass", this.lang);
         document.getElementById("urlHome").setAttribute("href", "/hu");
      document.getElementById("urlCTThiDiem")
        .setAttribute("href", this.lang + "/thietbithietyeu#thevimass");
      document.getElementById("urlCTQRTaiKhoan")
        .setAttribute("href", this.lang + "/thietbithietyeu#qrtaikhoan");
      document.getElementById("urlContactNV")
        .setAttribute("href", this.lang + "/thietbithietyeu#lienhe");
      document.getElementById("urlVivimass")
        .setAttribute("href", this.lang + "/thietbithietyeu#vivimass");
      document
        .getElementById("urlThietBi")
        .setAttribute("href", this.lang + "/thietbithietyeu#thietbi");
      document
        .getElementById("urlDichVu")
        .setAttribute("href", this.lang + "/thietbithietyeu#dichvu");
        document.getElementById("urlThanhtoan").setAttribute("href", this.lang + "/thietbithietyeu#thanhtoankhonginternet")

      const hash = window.location.hash;
      if (hash && hash.includes("#thietbithietyeu")) {
        this.changeTab("ThietBi");
      } else if (hash && hash.includes("#thietbi")) {
        this.changeTab("ThietBi");
      } else if (hash && hash.includes("#dichvu")) {
        this.changeTab("DichVu");
      } else if (hash && hash.includes("#thevimass")) {
        this.changeTab("thevimass");
      } else if (hash && hash.includes("#qrtaikhoan")) {
        this.changeTab("qRTaiKhoan");
      } else if (hash && hash.includes("#lienhe")) {
        this.changeTab("ContactNV");
      } else if (hash && hash.includes("#vivimass")) {
        this.changeTab("Vivimass");
      } else if (hash && hash.includes("#thanhtoankhonginternet")) {
        this.changeTab("CoSoYTeXa");
      }else{
        // Nếu không phù hợp với bất kỳ tab nào, mặc định hiển thị tab thevimass
        this.changeTab("ThietBi");
      }


    }
  },
  created() {
    const savedLanguage = localStorage.getItem("languages") || "vi";
    if (savedLanguage && languages[savedLanguage]) {
      this.currentLanguage = languages[savedLanguage];
    }
  },
  methods: {
    changeLanguage(lang) {
      this.currentLanguage = languages[lang];
      localStorage.setItem("languages", lang);
      const langReload = localStorage.getItem("languages");
      window.location.href = "/" + langReload + "/thietbithietyeu" + window.location.hash;
    },

    async performPostRequest(id, section) {
      this.lang = localStorage.getItem("languages") || "vi";

      try {
        // Thực hiện POST request
        const response = await axios.post(
          apiChiTietBaiViet,
          {
            id: id,
            langId: "0",
          },
        );
        const data = response.data.result;
        this.base64 = data[`content_${this.lang}`];
        this.base64Title = data[`title_${this.lang}`];

        var title = atob(this.base64Title);
        var decodedString = atob(this.base64);

        // Store content separately for each section
        if (section === "thevimass") {
          this.titleThevimass = decodeURIComponent(escape(title));
          this.contentThevimass = decodeURIComponent(escape(decodedString));
        } else if (section === "qRTaiKhoan") {
          this.titleQRTaiKhoan = decodeURIComponent(escape(title));
          this.contentQRTaiKhoan = decodeURIComponent(escape(decodedString));
        } else if (section === "ContactNV") {
          this.titleContactNV = decodeURIComponent(escape(title));
          this.contentContactNV = decodeURIComponent(escape(decodedString));
        } else if (section === "Vivimass") {
          this.titleVivimass = decodeURIComponent(escape(title));
          this.contentVivimass = decodeURIComponent(escape(decodedString));
        } else if (section === "CoSoYTeXa") {
          this.titleCoSoYTeXa = decodeURIComponent(escape(title));
          this.contentCoSoYTeXa = decodeURIComponent(escape(decodedString));
        } else if (section === "lienhe") {
          this.titleLienHe = decodeURIComponent(escape(title));
          this.contentLienHe = decodeURIComponent(escape(decodedString));
        }
      } catch (error) {
        console.error("Error:", error);
      }
    },
    toggleMenu() {
      this.isMenuVisible = !this.isMenuVisible;
    },
    changeTab(tab) {
      this.lang = localStorage.getItem("languages") || "vi";
      if (window.innerWidth <= 768) {
        this.isMenuVisible = false;
      }
      // Tạo một đối tượng để lưu trạng thái của các tab
      const tabStates = {
        thevimass: false,
        qRTaiKhoan: false,
        ContactNV: false,
        Vivimass: false,
        CoSoYTeXa: false,
        lienhe: false,
        ThietBi: false,
        DichVu: false,
      };

      // Thiết lập trạng thái cho tab được chọn
      tabStates[tab] = true;

      // Gọi hàm performPostRequest với các tham số tương ứng
      this.performPostRequest(this.getPostId(tab), tab, this.lang);

      // Cập nhật giá trị activeTab
      this.activeTab = tab;

      // Cập nhật các biến show dựa trên trạng thái của các tab
      this.showThevimass = tabStates.thevimass;
      this.showQRTaiKhoan = tabStates.qRTaiKhoan;
      this.showContactNV = tabStates.ContactNV;
      this.showVivimass = tabStates.Vivimass;
      this.showCoSoYTeXa = tabStates.CoSoYTeXa;
      this.showLienHe = tabStates.lienhe;
      this.activeThietBi = tabStates.ThietBi;
      this.activePhi = tabStates.DichVu;
    },

    getPostId(tab) {
      // Sử dụng một đối tượng để ánh xạ tab với id của bài viết tương ứng
      const postIdMap = {
        thevimass: "1546059256581d0h0r",
        // 1769226802983kMqwm
        qRTaiKhoan: "1767074609906xWs8N",
        ContactNV: "1690272053288yg3c7",
        Vivimass: "17615495777926yVTI",
        CoSoYTeXa: "1752549940885h0Sxh",
        lienhe: "1752549940885h0Sxh",
      };

      return postIdMap[tab];
    },
  },
};
</script>

<style scoped>
.topmenuactive {
    /* border-bottom: 5px solid red; */
    background: #68b362 !important;
    color: #ffffff !important;
}</style>